import gql from 'graphql-tag';

export const GET_USER_SERVICES_SUMMARY = gql`
	query($id: String) {
		getUser(id: $id) {
			id
			collectedVariance
			totalServiceRuns
			totalServiceDockets
			serviceDocketStatistics {
				servicesConfirmedPercentage
				selectionsChangedPercentage
				selectionsChangedAverage
			}
		}
	}
`;

